<template>
  <div style="display: inline-block">
    <div class="colum">
      <span @click="certificateFn('certificate')" class="com-normal-btn">
        <el-badge :is-dot="rowData.hasCert == 1" class="color-success"
          >证书/出证</el-badge
        >
      </span>
      <span
        v-if="requestType"
        @click="applicationArbitrationFn('certificate')"
        class="com-normal-btn"
      >
        <el-badge class="color-success">申请仲裁</el-badge>
      </span>
<!--              v-if="evidenceFn && !requestType"-->
      <span
        v-if="evidenceFn && !requestType && !isInDingTalk"
        id="tag-copy"
        :data-clipboard-text="vpresId"
        @click="storeCertificateFn('copy')"
        class="com-normal-btn"
      >
        <el-badge :is-dot="false" class="color-success">存证查询</el-badge>
      </span>
    </div>

    <!-- 选择框   -->
    <el-dialog
      :modal-append-to-body="false"
      :visible.sync="sSDialogVisible"
      title="请选择主体身份"
      width="500px"
      :close-on-click-modal="false"
    >
      <div
        v-if="sSDialogArr && sSDialogArr.length > 0"
        style="padding: 10px 20px"
      >
        <template v-for="(item, index) in sSDialogArr">
          <div :key="index">
            <el-radio v-model="choosedCert" :label="index">{{
              item.signatoryFullName || item.idenName
            }}</el-radio>
          </div>
        </template>
      </div>
      <div slot="footer" class="dialog-footer">
        <el-button size="small" @click="sSDialogVisible = false">
          取消
        </el-button>
        <el-button
          id="tag-copy1"
          :data-clipboard-text="vpresId"
          @click="onSelectCret(sSDialogArr[choosedCert])"
          size="small"
          type="danger"
        >
          确定
        </el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import Clipboard from "clipboard";
import { ApiMethods, configUrl } from "@/assets/js/http-serve/http-methods";
import { ApiCorpMethods } from "@/assets/js/http-serve/corp/http-methods";
import { isInDingTalk } from "../../assets/js/utils/ding-env";
import GlobalConfig from "../../assets/js/config/global";

export default {
  name: "existing-evidence",
  props: {
    rowData: {
      type: Object,
      default: () => { }
    },
    enterpriseSubjectType: {
      type: [Number, String],
      default: '',
    },
    requestType: {
      type: String,
      default: ""
    },
    newUrl: {
      type: Number,
      default: 1
    },
  },
  data () {
    return {
      isInDingTalk,
      choosedCert: 0,
      vpresId: "",
      sSDialogVisible: false, // 请选择出证主体身份弹出框显示
      dialogType: "", //窗口类型
      sSDialogArr: [], //窗口列表
      applyArbitration: false,
    };
  },
  computed: {
    currentIsCorpUser () {
      if (
        (this.$store.getters.currentAuthUser || {}).hasOwnProperty("superFlag")
      ) {
        return true;
      }
      return false;
    }
  },
  methods: {
    evidenceFn () {
      return this.rowData.signInfoVOS
        ? this.rowData.signInfoVOS.some(item => {
          return item.videncePresId || item.presId;
        })
        : false;
    },
    //确定
    onSelectCret (data) {
      this.sSDialogVisible = false;
      if (this.dialogType === "copy") {
        this.vpresId = (data.videncePresId || data.presId)
          .toString()
          .padStart(10, "0");
        this.copyFn("tag-copy1");
      } else {
        this.gotoRedirectTesity(data);
      }
    },
    copyFn (id) {
      const clipboard = new Clipboard("#" + id);
      clipboard.on("success", e => {
        this.$message({
          type: "success",
          message: "备案号已复制"
        });
        this.$emit("copyTextToQueryEmit", this.vpresId);
        // 释放内存
        clipboard.destroy();
      });
      clipboard.on("error", e => {
        // 不支持复制
        this.$message({
          type: "waning",
          message: "该浏览器不支持自动复制"
        });
        // 释放内存
        clipboard.destroy();
      });
    },
    //申请仲裁
    applicationArbitrationFn () {
      this.certificateFn('certificate', true)
    },
    //-------------证书---
    async certificateFn (type, applyArbitration = false) {
      this.applyArbitration = applyArbitration;
      this.dialogType = type;
      let _this = this;
      let _param = {
        signNo: this.rowData.signInfoNo || "",
        applyNo: this.rowData.applyNo || ""
      };
      if (!_param.ts || !_param.sign) {
        let viewUrlParam = { signNo: _param.signNo, applyNo: _param.applyNo };
        let viewUrlRes;
        if (
          this.$route.path.indexOf("console") > -1 ||
          this.requestType === "memberContract"
        ) {
          // 控制台里面调用/c/m
          viewUrlRes = ![1, 2, 3].includes(this.enterpriseSubjectType) ?
            await ApiCorpMethods.ContractController.viewUrl(viewUrlParam) :
            await ApiMethods.UserApplySignController.viewUrl({  //企业主体
              ...viewUrlParam,
              corpQuery: 1,
            });
        } else {
          // 工作台里面分（个人企业调用/i）和（集团调用/c）
          if (!this.currentIsCorpUser) {
            // 个人或者企业
            viewUrlRes = await ApiMethods.UserApplySignController.viewUrl(
              viewUrlParam
            );
          } else {
            // 集团
            // viewUrlRes = await ApiCorpMethods.ContractController.viewUrl(
            viewUrlRes = await ApiCorpMethods.ContractController.corpViewUrl(
              viewUrlParam
            );
          }
        }
        // 接口调用重构 end

        if (!viewUrlRes.success) {
          return _this.$message.error(
            viewUrlRes.description || "初始化数据失败"
          );
        }
        _param = viewUrlRes.data;
      }
      if (
        this.$store.getters.currentAuthUser &&
        this.$store.getters.currentAuthUser.corpUserId
      ) {
        _param.corpUserId = this.$store.getters.currentAuthUser.corpUserId;
      }
      let certiListRes = await ApiMethods.ApplySignController.certiList(_param);
      if (certiListRes.success) {
        if (!certiListRes.data || certiListRes.data.lengt == 0)
          return _this.$message.error("初始化数据失败");
        if (certiListRes.data.length === 1) {
          if (type === "copy") {
            this.vpresId = certiListRes.data[0].presId
              .toString()
              .padStart(10, "0");
            this.copyFn("tag-copy");
          } else {
            let _data = { ...certiListRes.data[0] };
            return _this.gotoRedirectTesity(_data);
          }
        }
        if (certiListRes.data.length > 1) {
          this.sSDialogArr = certiListRes.data;
          this.sSDialogVisible = true;
        }
      } else {
        _this.$message.error(certiListRes.description);
      }
    },
    //  --------------------------存证----------------------------
    async storeCertificateFn (type) {
      this.dialogType = type;
      if (this.rowData.signInfoVOS.length === 1) {
        console.log(this.rowData,this.rowData.signInfoVOS,this.rowData.signInfoVOS[0],this.rowData.signInfoVOS[0].videncePresId || this.rowData.signInfoVOS[0].presId)
        if (type === "copy") {
          this.vpresId = (
            this.rowData.signInfoVOS[0].videncePresId ||
            this.rowData.signInfoVOS[0].presId
          )
            .toString()
            .padStart(10, "0");
          this.copyFn("tag-copy");
        } else {
          let _data = { ...this.rowData.signInfoVOS[0] };
          return _this.gotoRedirectTesity(_data);
        }
      }
      if (this.rowData.signInfoVOS.length > 1) {
        this.sSDialogArr = this.rowData.signInfoVOS;
        this.sSDialogVisible = true;
      }
    },
    async gotoRedirectTesity (data) {
      console.log("gotoRedirectTesity参数打印", data);
      // newUrl 0 旧业面 1 新页面
      let _this = this,
        ow = null;
      if (!isInDingTalk) ow = window.open("about:blank");
      // data.newUrl = _this.newUrl;
      if (
        this.$store.getters.currentAuthUser &&
        this.$store.getters.currentAuthUser.corpUserId
      ) {
        data.corpUserId = this.$store.getters.currentAuthUser.corpUserId;
      }
      data.newUrl = 1;
      let redirectTesityRes = '';
      //申请仲裁
      if (this.applyArbitration) {
        data.backUrl = GlobalConfig.domain.junziqianWebOp + '/judicialService/applyArbitration';
        redirectTesityRes = await ApiMethods.CertiController.redirectToArb(
          data
        );
      } else { //申请出证
        redirectTesityRes = await ApiMethods.CertiController.redirectTesity(
          data
        );
      }
      if (redirectTesityRes.success) {
        console.log("redirectTesityRes.data", redirectTesityRes.data);
        const _href = redirectTesityRes.data
        if (!isInDingTalk) {
          ow.location.href = _href;
        } else {
          const a = document.createElement("a");
          a.style.display = "none";
          a.href = _href;
          document.body.append(a);
          a.click();
          setTimeout(() => {
            a.remove();
          }, 1000);
        }
      } else {
        _this.$message.error(redirectTesityRes.description || this.$tip);
        ow.close();
      }
    }
  }
};
</script>

<style scoped lang="less">
.colum {
  display: flex;
  flex-direction: column;
}
/deep/ .el-badge__content.is-fixed.is-dot {
  right: 3px;
  top: 4px;
}
.color-success,
.color-danger {
  cursor: pointer;
  margin-right: 8px;
  color: #290202;
  font-weight: bold;

  &:hover {
    color: #ec1c1c;
  }
}
.g-certi-dialog .el-dialog__footer {
  -webkit-box-shadow: 0 3px 10px rgba(0, 0, 0, 0.17);
  box-shadow: 0 3px 10px rgba(0, 0, 0, 0.17);
  padding: 10px 15px;
}
.g-certi-dialog-conent {
  box-sizing: border-box;
  width: 100%;
  padding: 10px 80px 15px 205px;
  display: flex;
  .img-certi {
    box-sizing: border-box;
    min-height: 636px;
    flex: 1;
    padding-right: 40px;
  }
  .img-certi-img,
  .img-certi-a {
    width: 100%;
    height: auto;
  }
  .right-btn-warp {
    flex: 0 0 175px;
    padding-top: 26px;
  }
  .g-certi-btn {
    width: 100%;
    height: 35px;
    display: block;
    margin-bottom: 15px;
    margin-left: 0;
    &:hover {
      background-color: #fff;
      color: rgba(236, 28, 28, 1);
      border-color: rgba(236, 28, 28, 1);
    }
  }
}
</style>



// WEBPACK FOOTER //
// components/apply-list/existing-evidence.vue